import { PageHeader } from '@repo/ui/components/page-header'
import { Skeleton } from '@repo/ui/skeleton'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@repo/ui/tabs'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { translateKey, useTranslation } from '@/lib/i18n'
import { emailTextQueryOptions } from '../-query/query-options'
import { EmailTextEditor } from './-components/email-text-editor'

export const Route = createFileRoute('/(private)/email-texts/$code/')({
	staticData: {
		// The name of the email, the page's only heading.
		breadcrumb: ({ params }) => ({
			label: translateKey(`admin-email-texts:emails.${params.code}`),
			status: 'success'
		})
	},
	component: EmailTextPage
})

/** One email, one tab per language, each with its editor and history. */
function EmailTextPage() {
	const { t } = useTranslation()
	const { code } = Route.useParams()
	const query = useQuery(emailTextQueryOptions(code))

	if (query.isLoading) {
		return <Skeleton className='m-6 h-96' />
	}
	if (!query.data) {
		return (
			<p className='p-6 text-muted-foreground text-sm'>
				{t('admin-email-texts:not_found')}
			</p>
		)
	}
	const text = query.data

	return (
		<main className='flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto p-4 md:p-6'>
			<PageHeader
				title={translateKey(`admin-email-texts:emails.${text.code}`)}
			/>
			<Tabs defaultValue='it'>
				<div className='w-full border-border border-b'>
					<TabsList variant='line'>
						{text.locales.map((locale) => (
							<TabsTrigger
								key={locale.locale}
								value={locale.locale}
							>
								{t(
									`admin-email-texts:locales.${locale.locale}`
								)}
							</TabsTrigger>
						))}
					</TabsList>
				</div>
				{text.locales.map((locale) => (
					<TabsContent key={locale.locale} value={locale.locale}>
						<EmailTextEditor
							// Remount after a save so the editor starts from the new text.
							key={`${locale.locale}-${locale.current.version}`}
							locale={locale}
							text={text}
						/>
					</TabsContent>
				))}
			</Tabs>
		</main>
	)
}
